import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';

import { UiModule } from '@lockton-apps/shared/ui/lui';
import { MaterialModule } from '@lockton-apps/material';

import { DocumentUploadDialogComponent } from '../document-upload-dialog.component';
import { DocumentUploadRow } from '../models';

@Component({
    selector: 'la-contact-document-upload-dialog',
    imports: [
        CommonModule,
        DocumentUploadDialogComponent,
        UiModule,
        MaterialModule,
        ReactiveFormsModule,
    ],
    templateUrl: './contact-document-upload-dialog.component.html',
    styleUrls: ['./contact-document-upload-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactDocumentUploadDialogComponent {
  fileDataSource = new MatTableDataSource<DocumentUploadRow>();
  displayedCols = ['document', 'remove'];

  onFilesChanged(rows: DocumentUploadRow[]) {
    this.fileDataSource.data = rows;
  }
}
